import { useState, createContext, ReactNode, useEffect } from 'react';
import UnsupportedCloudWallet from '@/containers/home/Dialog/UnsupportedCloudWallet';
import { useConnectWallet } from '@/hooks';
import { NoSSR } from '@web3/base-components';
import { useHybirdWallet } from '@web3/base-hooks';
import { WalletType } from '@web3/base-utils';

export const SwitchWalletContext = createContext<{
  openSwitchWalletModal: () => void;
}>({
  openSwitchWalletModal: () => undefined,
});

SwitchWalletContext.displayName = 'SwitchWalletContext';
interface Props {
  children: ReactNode;
}

export const SwitchWalletProvider = (props: Props) => {
  const { children } = props;
  const [showModal, setShowModal] = useState(false);
  const { connectWallet } = useConnectWallet();
  const { walletType } = useHybirdWallet();

  const openSwitchWalletModal = () => {
    setShowModal(true);
  };

  useEffect(() => {
    if (walletType === WalletType.MNEMONIC_PHRASE) {
      setShowModal(false);
    }
  }, [walletType]);

  return (
    <SwitchWalletContext.Provider
      value={{
        openSwitchWalletModal,
      }}
    >
      {children}
      <NoSSR>
        <UnsupportedCloudWallet
          visible={showModal}
          onClose={() => {
            setShowModal(false);
          }}
          onConfirm={() => {
            connectWallet();
          }}
        />
      </NoSSR>
    </SwitchWalletContext.Provider>
  );
};
